

export class PickupDeliveryBulkActionEnum {
    
	static Schedule: number = 10; 
	static Cancel: number = 20; 
	static Delete: number = 30; 
	static SendReschedulingText: number = 40; 
	static SendReschedulingEmail: number = 50; 
	static ChangeTruck: number = 60; 
	static UnassignTruck: number = 70; 
	static SendArrivalWindowText: number = 100; 
	static SendArrivalWindowEmail: number = 110; 
	static SendArrivalWindowEmailAndText: number = 120; 


	static getChoices(): any[] {
		return [
		{
			Value: PickupDeliveryBulkActionEnum.Schedule, Text: 'Schedule'
	},{
			Value: PickupDeliveryBulkActionEnum.Cancel, Text: 'Cancel'
	},{
			Value: PickupDeliveryBulkActionEnum.Delete, Text: 'Delete'
	},{
			Value: PickupDeliveryBulkActionEnum.SendReschedulingText, Text: 'Send Rescheduling Text'
	},{
			Value: PickupDeliveryBulkActionEnum.SendReschedulingEmail, Text: 'Send Rescheduling Email'
	},{
			Value: PickupDeliveryBulkActionEnum.ChangeTruck, Text: 'Change Truck'
	},{
			Value: PickupDeliveryBulkActionEnum.UnassignTruck, Text: 'Unassign Truck'
	},{
			Value: PickupDeliveryBulkActionEnum.SendArrivalWindowText, Text: 'Send Arrival Window Text'
	},{
			Value: PickupDeliveryBulkActionEnum.SendArrivalWindowEmail, Text: 'Send Arrival Window Email'
	},{
			Value: PickupDeliveryBulkActionEnum.SendArrivalWindowEmailAndText, Text: 'Send Arrival Window Email And Text'
	}
			
		];
	}

}
